if (!customElements.get('venja-collection-links')) {
  customElements.define('venja-collection-links', class extends HTMLElement {
    connectedCallback() {
      this.updateOverflow = () => {
        this.toggleAttribute('data-overflow-start', this.scrollLeft > 2);
        this.toggleAttribute('data-overflow-end', this.scrollWidth - this.clientWidth - this.scrollLeft > 2);
      };
      this.addEventListener('scroll', this.updateOverflow, { passive: true });
      this.resizeObserver = new ResizeObserver(this.updateOverflow);
      this.resizeObserver.observe(this);
      this.initialFrame = requestAnimationFrame(() => {
        const current = this.querySelector('[aria-current="page"]');
        if (current && matchMedia('(max-width: 749px)').matches) {
          const offset = current.getBoundingClientRect().left - this.getBoundingClientRect().left;
          this.scrollLeft += offset - (this.clientWidth - current.offsetWidth) / 2;
        }
        this.updateOverflow();
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.initialFrame);
      this.removeEventListener('scroll', this.updateOverflow);
      this.resizeObserver.disconnect();
    }
  });
}
